// The small dark uppercase section label used throughout the new player
// (MISSION BAR, STORY STREAM, STATUS STRIP, ...). Visual-only.
export function SectionLabel({ children }) {
  return <span className="g2-label">{children}</span>
}
